/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import { API } from "../api";
import { CLIENT_SERVICE_TYPES } from "../constants/url.constant";

export const GET_CLIENT_SERVICE_TYPES = "GET_CLIENT_CLIENT_SERVICE_TYPES";
export const GET_CLIENT_SERVICE_TYPE = "GET_CLIENT_SERVICE_TYPE";
export const ADD_CLIENT_SERVICE_TYPE = "ADD_CLIENT_SERVICE_TYPE";
export const DELETE_CLIENT_SERVICE_TYPE = "DELETE_CLIENT_SERVICE_TYPE";
export const UPDATE_CLIENT_SERVICE_TYPE = "UPDATE_CLIENT_SERVICE_TYPE";
export const RESET_CLIENT_SERVICE = "RESET_CLIENT_SERVICE";

export const resetClientService = () => ({
  type: RESET_CLIENT_SERVICE
});

export const getAllClientServices = (params) => {
  return async (dispatch) => {
    try {
      const res = await API.get("admin/client-services", { params });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getClientServiceTypes = (clientId, params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        CLIENT_SERVICE_TYPES.replace("clientId", clientId),
        {
          params
        }
      );
      if (Object.keys(params).length) {
        dispatch({
          type: GET_CLIENT_SERVICE_TYPES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getServiceTypeByID = (clientId, serviceId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        `${CLIENT_SERVICE_TYPES.replace("clientId", clientId)}/${serviceId}`
      );
      dispatch({
        type: GET_CLIENT_SERVICE_TYPE,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addClientServiceType = (clientId, data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(
        CLIENT_SERVICE_TYPES.replace("clientId", clientId),
        data
      );
      dispatch({
        type: ADD_CLIENT_SERVICE_TYPE,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateClientServiceType = (clientId, serviceId, body) => {
  return async (dispatch) => {
    try {
      await API.put(
        `${CLIENT_SERVICE_TYPES.replace("clientId", clientId)}/${serviceId}`,
        body
      );
      dispatch({
        type: UPDATE_CLIENT_SERVICE_TYPE,
        payload: { serviceId, ...body }
      });
    } catch (error) {
      throw error;
    }
  };
};

export const deleteClientServiceType = (clientId, serviceId) => {
  return async (dispatch) => {
    try {
      await API.delete(
        `${CLIENT_SERVICE_TYPES.replace("clientId", clientId)}/${serviceId}`);
      dispatch({
        type: DELETE_CLIENT_SERVICE_TYPE
      });
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = {
    clientServiceTypeTableRows: [],
    ClientServiceTypeTableColumns: [],
    totalRows: 0
  },
  { type, payload }
) {
  switch (type) {
    case RESET_CLIENT_SERVICE:
      return {
        ...state,
        clientServiceTypeTableRows: []
      };
    case GET_CLIENT_SERVICE_TYPES:
      return {
        ...state,
        ClientServiceTypeTableColumns: payload.columns,
        clientServiceTypeTableRows: payload.rows,
        totalRows: payload.count
      };
    case GET_CLIENT_SERVICE_TYPE:
      return {
        ...state,
        clientServiceDetail: payload
      };
    case ADD_CLIENT_SERVICE_TYPE:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        clientServiceTypeTableRows: [
          ...state.clientServiceTypeTableRows,
          { ...payload }
        ]
      };
    case DELETE_CLIENT_SERVICE_TYPE:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        clientServiceTypeTableRows: state.clientServiceTypeTableRows.filter(
          (client) => client.id !== payload
        )
      };
    case UPDATE_CLIENT_SERVICE_TYPE:
      return {
        ...state,
        clientServiceTypeTableRows: state.clientServiceTypeTableRows.map(
          (client) => (client.id === payload.id ? { ...payload } : client)
        )
      };
    default:
      return state;
  }
}
